import { Fragment, useEffect, useRef, useState } from 'react'
import {
  getAllMembers, publishNewsletter, updateNewsletter, getNewsletters, getGearchiveerdeNewsletters,
  archiveerNewsletter, herstelNewsletter, getNewsletterReadCounts, deleteNewsletter, MAX_ACTIEVE_NIEUWSBERICHTEN,
  sendMessage, sendBulkMessage, getMessages, toggleMemberStatus, supabase, lidEmail, sendPushNotification,
  subscribeToAlleMessages, getOngelezenPerLid, markeerGelezen,
  uploadNieuwsFoto, signInWithEmail, signOut, createMemberAccount, sendWelcomeEmail
} from '../lib/supabase'
import AdminStempelkaartTab from './AdminStempelkaartTab'
import AdminTeamTab from './AdminTeamTab'
import { renderLinks } from '../utils/renderLinks'

// Leesbaar daglabel: "Vandaag", "Gisteren" of bv. "9 juni"
function dagLabel(datum) {
  const dt = new Date(datum)
  const nu = new Date()
  const zelfdeDag = (a, b) => a.toDateString() === b.toDateString()
  const gisteren = new Date(nu)
  gisteren.setDate(nu.getDate() - 1)
  if (zelfdeDag(dt, nu)) return 'Vandaag'
  if (zelfdeDag(dt, gisteren)) return 'Gisteren'
  return dt.toLocaleDateString('nl-NL', {
    day: 'numeric', month: 'long',
    ...(dt.getFullYear() !== nu.getFullYear() ? { year: 'numeric' } : {}),
  })
}

export default function AdminPage() {
  const [authed, setAuthed] = useState(false)
  const [checking, setChecking] = useState(true)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [pinError, setPinError] = useState('')
  const [loggingIn, setLoggingIn] = useState(false)
  const [tab, setTab] = useState('newsletters')
  const [ongelezen, setOngelezen] = useState({})

  // Bij openen: is er al een ingelogde beheerder? Dan meteen door.
  useEffect(() => {
    let actief = true
    ;(async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        if (session) {
          const { data: isAdmin } = await supabase.rpc('is_admin')
          if (actief && isAdmin === true) setAuthed(true)
        }
      } catch { /* niet ingelogd of check niet beschikbaar */ }
      if (actief) setChecking(false)
    })()
    return () => { actief = false }
  }, [])

  async function handleAdminLogin(e) {
    e.preventDefault()
    if (!email.trim() || !password.trim()) return
    setPinError(''); setLoggingIn(true)
    try {
      await signInWithEmail(email.trim().toLowerCase(), password)
      const { data: isAdmin, error } = await supabase.rpc('is_admin')
      if (error || isAdmin !== true) {
        await signOut()
        setPinError('Dit account heeft geen beheerdersrechten.')
        return
      }
      setAuthed(true)
    } catch {
      setPinError('Inloggen mislukt. Controleer e-mail en wachtwoord.')
    } finally {
      setLoggingIn(false)
    }
  }

  async function handleLogout() {
    await signOut()
    setAuthed(false)
    setEmail(''); setPassword('')
  }

  useEffect(() => {
    if (!authed) return
    getOngelezenPerLid().then(setOngelezen).catch(() => {})
    const channel = subscribeToAlleMessages(() => {
      getOngelezenPerLid().then(setOngelezen).catch(() => {})
    })
    return () => channel.unsubscribe()
  }, [authed])

  if (checking) return (
    <div className="login-page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="spinner" />
    </div>
  )

  if (!authed) return (
    <div className="login-page">
      <div style={{ position: 'relative', height: 180, flexShrink: 0 }}>
        <img src="/gym-header.jpg" alt="Vitaal Sterk" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 40%' }} />
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(30,36,22,0.5)' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 4, background: '#e76622' }} />
        <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', padding: '0 28px' }}>
          <img src="/logo.png" alt="Vitaal Sterk" style={{ height: 90, objectFit: 'contain' }} />
        </div>
      </div>
      <div className="login-body">
        <p style={{ fontFamily: 'Montserrat', fontSize: 11, color: 'var(--muted)', marginBottom: 24, textTransform: 'uppercase', letterSpacing: '0.1em' }}>
          Beheerderspaneel
        </p>
        <form onSubmit={handleAdminLogin}>
          <div className="form-group">
            <label className="form-label">E-mailadres</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="beheerder@vitaal-sterk.nl"
              autoCapitalize="none"
              autoCorrect="off"
              inputMode="email"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Wachtwoord</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••" />
          </div>
          {pinError && <p className="error-msg">{pinError}</p>}
          <button className="btn-primary" style={{ marginTop: 16 }} disabled={loggingIn}>
            {loggingIn ? 'Bezig…' : 'Inloggen'}
          </button>
        </form>
        <div style={{ position: 'absolute', bottom: 'max(24px, calc(env(safe-area-inset-bottom) + 16px))', left: 0, right: 0, textAlign: 'center' }}>
          <a href="/" style={{ fontSize: 12, color: 'var(--muted)', textDecoration: 'none' }}>← Terug naar ledenapp</a>
        </div>
      </div>
    </div>
  )

  return (
    <div className="app-shell">
      <div className="top-bar">
        <img src="/logo.png" alt="Vitaal Sterk" style={{ height: 36, width: 'auto', objectFit: 'contain' }} />
        <span style={{ fontSize: 16, color: '#fff', fontFamily: 'Montserrat', fontWeight: 800, letterSpacing: '0.08em', marginLeft: 'auto' }}>BEHEERDER</span>
        <button onClick={handleLogout} style={{ marginLeft: 14, background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', borderRadius: 16, padding: '6px 14px', fontSize: 12, fontWeight: 700, fontFamily: 'Montserrat', cursor: 'pointer' }}>
          Uitloggen
        </button>
      </div>

      <div className="tab-bar" style={{ flexShrink: 0, margin: 0, padding: '12px 14px', background: 'var(--bg)', borderBottom: '1px solid var(--border)' }}>
        {[['newsletters', 'Nieuws'], ['messages', 'Berichten'], ['stempel', 'Fase'], ['team', 'Team'], ['members', 'Leden']].map(([t, label]) => {
            const totaalOngelezen = t === 'messages' ? Object.values(ongelezen).reduce((a, b) => a + b, 0) : 0
            return (
              <button key={t} className={`tab-btn ${tab === t ? 'active' : ''}`} onClick={() => setTab(t)} style={{ position: 'relative' }}>
                {label}
                {totaalOngelezen > 0 && (
                  <span style={{ position: 'absolute', top: -6, right: -4, background: '#e76622', color: '#fff', borderRadius: 9, minWidth: 18, height: 18, padding: '0 4px', fontSize: 10, fontWeight: 800, fontFamily: 'Montserrat', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid var(--bg)', boxSizing: 'border-box' }}>
                    {totaalOngelezen > 9 ? '9+' : totaalOngelezen}
                  </span>
                )}
              </button>
            )
          })}
      </div>

      <div className="page-content">
        {tab === 'newsletters' && <NewslettersTab />}
        {tab === 'messages' && <AdminMessagesTab ongelezen={ongelezen} setOngelezen={setOngelezen} />}
        {tab === 'stempel' && <AdminStempelkaartTab />}
        {tab === 'team' && <AdminTeamTab />}
        {tab === 'members' && <MembersTab />}
      </div>
    </div>
  )
}

// ── Nieuwsbrieven ─────────────────────────────────────

function NewslettersTab() {
  const [title, setTitle] = useState('')
  const [category, setCategory] = useState('announcement')
  const [body, setBody] = useState('')
  const [foto, setFoto] = useState(null)
  const [fotoPreview, setFotoPreview] = useState(null)
  const [loading, setLoading] = useState(false)
  const [feedback, setFeedback] = useState('')
  const [items, setItems] = useState([])
  const [archiefItems, setArchiefItems] = useState([])
  const [toonArchief, setToonArchief] = useState(false)
  const [editingId, setEditingId] = useState(null)
  const [editingFotoUrl, setEditingFotoUrl] = useState(null)
  const [readCounts, setReadCounts] = useState({})
  const formRef = useRef(null)

  useEffect(() => { loadItems() }, [])

  async function loadItems() {
    const [data, archief, counts] = await Promise.all([getNewsletters(), getGearchiveerdeNewsletters(), getNewsletterReadCounts()])
    setItems(data)
    setArchiefItems(archief)
    setReadCounts(counts)
  }

  async function handleArchiveer(id) {
    await archiveerNewsletter(id)
    loadItems()
  }

  async function handleHerstel(id) {
    await herstelNewsletter(id)
    loadItems()
  }

  function handleFotoKiezen(e) {
    const file = e.target.files?.[0]
    if (!file) return
    setFoto(file)
    setFotoPreview(URL.createObjectURL(file))
  }

  function startEdit(item) {
    setEditingId(item.id)
    setTitle(item.title || '')
    setCategory(item.category || 'announcement')
    setBody(item.body || '')
    setEditingFotoUrl(item.foto_url || null)
    setFoto(null)
    setFotoPreview(item.foto_url || null)
    setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60)
  }

  function annuleerBewerken() {
    setEditingId(null); setEditingFotoUrl(null)
    setTitle(''); setBody(''); setCategory('announcement')
    setFoto(null); setFotoPreview(null)
  }

  async function handlePublish(e) {
    e.preventDefault()
    if (!title.trim() || !body.trim()) return
    setLoading(true)
    try {
      let foto_url = editingId ? editingFotoUrl : null
      if (foto) foto_url = await uploadNieuwsFoto(foto)
      if (editingId) {
        await updateNewsletter(editingId, { title, category, body, foto_url })
        setFeedback('Nieuwsbrief bijgewerkt.')
      } else {
        await publishNewsletter({ title, category, body, foto_url })
        setFeedback('Nieuwsbrief gepubliceerd.')
      }
      annuleerBewerken()
      loadItems()
    } catch (err) {
      setFeedback('Fout: ' + err.message)
    } finally {
      setLoading(false)
      setTimeout(() => setFeedback(''), 3000)
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Nieuwsbrief verwijderen?')) return
    await deleteNewsletter(id)
    loadItems()
  }

  return (
    <div>
      <div className="card" ref={formRef} style={{ scrollMarginTop: 8 }}>
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 14, color: 'var(--muted)', fontFamily: 'Montserrat' }}>
          {editingId ? 'Nieuwsbrief bewerken' : 'Nieuwe nieuwsbrief'}
        </p>
        <form onSubmit={handlePublish}>
          <div className="form-group">
            <label className="form-label">Titel</label>
            <input value={title} onChange={e => setTitle(e.target.value)} placeholder="bijv. Zomerschema update" />
          </div>
          <div className="form-group">
            <label className="form-label">Categorie</label>
            <select value={category} onChange={e => setCategory(e.target.value)}>
              <option value="announcement">Aankondiging</option>
              <option value="letop">Let op!</option>
              <option value="news">Nieuws</option>
              <option value="event">Evenement</option>
              <option value="diversen">Diversen</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Bericht</label>
            <textarea value={body} onChange={e => setBody(e.target.value)} placeholder="Schrijf je nieuwsbrief hier…" />
            <p style={{ fontSize: 11, color: 'var(--muted)', margin: '6px 0 0', lineHeight: 1.5 }}>
              Tip: gebruik <code style={{ background: 'var(--border)', padding: '1px 5px', borderRadius: 4, fontSize: 11 }}>[linktekst](https://url.nl)</code> voor een klikbare link.
            </p>
            {/\[.+?\]\(https?:\/\/.+?\)/.test(body) && (
              <div style={{ marginTop: 12 }}>
                <p style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 6 }}>
                  Voorbeeld — zo ziet het lid dit
                </p>
                <div style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 12px rgba(30,36,22,0.10)', borderLeft: '4px solid var(--green)', background: 'var(--bg)' }}>
                  {fotoPreview && (
                    <img src={fotoPreview} alt="preview" style={{ width: '100%', maxHeight: 220, objectFit: 'cover', display: 'block' }} />
                  )}
                  <div style={{ padding: '14px 16px' }}>
                    <p style={{ fontFamily: 'Montserrat', fontWeight: 700, fontSize: 15, margin: '0 0 4px', color: 'var(--text)' }}>
                      {title || 'Titel van het bericht'}
                    </p>
                    <p style={{ fontSize: 14, lineHeight: 1.8, color: 'var(--text)', margin: 0 }}>
                      {renderLinks(body)}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="form-group">
            <label className="form-label">Foto (optioneel)</label>
            <input type="file" accept="image/*" onChange={handleFotoKiezen} style={{ fontSize: 12 }} />
            {fotoPreview && (
              <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src={fotoPreview} alt="preview" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 6, flexShrink: 0 }} />
                <span style={{ fontSize: 11, color: 'var(--muted)', flex: 1 }}>Foto geselecteerd — zichtbaar in voorbeeld hierboven</span>
                <button type="button" onClick={() => { setFoto(null); setFotoPreview(null) }} style={{ background: 'transparent', border: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 12 }}>Verwijder</button>
              </div>
            )}
          </div>
          {feedback && <p className="success-msg">{feedback}</p>}
          <button className="btn-primary" disabled={loading}>
            {loading ? 'Bezig…' : (editingId ? 'Wijzigingen opslaan' : 'Publiceren')}
          </button>
          {editingId && (
            <button type="button" onClick={annuleerBewerken} className="btn-ghost" style={{ marginTop: 8 }}>
              Annuleer bewerken
            </button>
          )}
        </form>
      </div>

      {items.length > 0 && (
        <div className="card">
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, color: 'var(--muted)', fontFamily: 'Montserrat' }}>
            Gepubliceerd — {items.length}/{MAX_ACTIEVE_NIEUWSBERICHTEN}
          </p>
          <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 12 }}>
            Bij het 13e bericht wordt het oudste automatisch naar het archief verplaatst.
          </p>
          {items.map(item => (
            <div key={item.id} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
              {item.foto_url && (
                <img src={item.foto_url} alt="" style={{ width: 52, height: 52, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }} />
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 13, fontWeight: 600 }}>{item.title}</p>
                <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 3 }}>{item.category}</p>
                {item.body && (
                  <p style={{ fontSize: 11, color: 'var(--text)', lineHeight: 1.4, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                    {item.body}
                  </p>
                )}
                <p style={{ fontSize: 11, color: 'var(--green-dark)', fontWeight: 700, marginTop: 4 }}>
                  👁 {readCounts[item.id] || 0} {(readCounts[item.id] || 0) === 1 ? 'lid heeft' : 'leden hebben'} dit geopend
                </p>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
                <button onClick={() => startEdit(item)} style={{ background: 'transparent', border: 'none', color: 'var(--green-dark)', cursor: 'pointer', fontSize: 12, fontWeight: 700, textAlign: 'right' }}>Bewerken</button>
                <button onClick={() => handleArchiveer(item.id)} style={{ background: 'transparent', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 12, textAlign: 'right' }}>Archiveer</button>
                <button onClick={() => handleDelete(item.id)} style={{ background: 'transparent', border: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 12, textAlign: 'right' }}>Verwijder</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Archief */}
      <div className="card">
        <button
          onClick={() => setToonArchief(v => !v)}
          style={{ background: 'transparent', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', padding: 0 }}
        >
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat' }}>
            {toonArchief ? '▾' : '▸'} Archief — {archiefItems.length}
          </p>
        </button>
        {toonArchief && (
          archiefItems.length === 0 ? (
            <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 10 }}>Nog geen gearchiveerde berichten.</p>
          ) : (
            archiefItems.map(item => (
              <div key={item.id} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', padding: '10px 0', borderBottom: '1px solid var(--border)', marginTop: 10 }}>
                {item.foto_url && (
                  <img src={item.foto_url} alt="" style={{ width: 52, height: 52, objectFit: 'cover', borderRadius: 8, flexShrink: 0, opacity: 0.6 }} />
                )}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--muted)' }}>{item.title}</p>
                  <p style={{ fontSize: 11, color: 'var(--muted)' }}>{item.category}</p>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => handleHerstel(item.id)} style={{ background: 'transparent', border: 'none', color: 'var(--green-dark)', cursor: 'pointer', fontSize: 12, fontWeight: 700, textAlign: 'right' }}>Re-post</button>
                  <button onClick={() => handleDelete(item.id)} style={{ background: 'transparent', border: 'none', color: 'var(--red)', cursor: 'pointer', fontSize: 12, textAlign: 'right' }}>Verwijder</button>
                </div>
              </div>
            ))
          )
        )}
      </div>
    </div>
  )
}

// ── Berichten ─────────────────────────────────────────

function AdminMessagesTab({ ongelezen, setOngelezen }) {
  const [members, setMembers] = useState([])
  const [selected, setSelected] = useState(null)
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)
  const [thread, setThread] = useState([])
  const [zoek, setZoek] = useState('')
  const [ledenMetBerichten, setLedenMetBerichten] = useState(new Set())
  const [laaatsteBerichtDatum, setLaaatsteBerichtDatum] = useState({})
  const bottomRef = useRef(null)
  const kiesRef = useRef(null)

  const [bulkText, setBulkText] = useState('')
  const [bulkLoading, setBulkLoading] = useState(false)
  const [bulkFeedback, setBulkFeedback] = useState('')
  const overzichtRequestId = useRef(0)

  async function handleBulkSend(e) {
    e.preventDefault()
    if (!bulkText.trim()) return
    if (!window.confirm(`Dit bericht wordt verstuurd naar alle actieve leden. Doorgaan?`)) return
    setBulkLoading(true)
    setBulkFeedback('')
    try {
      const aantal = await sendBulkMessage(bulkText.trim())
      await refreshBerichtenOverzicht()
      await sendPushNotification("Nieuw bericht", bulkText.trim())
      setBulkText('')
      setBulkFeedback(`✓ Verstuurd naar ${aantal} leden`)
    } catch (err) {
      setBulkFeedback('Fout: ' + err.message)
    } finally {
      setBulkLoading(false)
      setTimeout(() => setBulkFeedback(''), 4000)
    }
  }

  async function refreshBerichtenOverzicht() {
    // Let op: dit haalt één rij per lid op (via een db-view die per lid het laatste
    // bericht aggregeert), en niet alle berichten los — anders loop je tegen de
    // standaard rijlimiet van Supabase aan zodra de messages-tabel groeit (zoals na
    // een bulkbericht), en zakt de sortering terug naar alfabetisch.
    //
    // Er lopen meerdere triggers door elkaar (mount, versturen, gesprek openen, live
    // updates) die dit verzoek allemaal onafhankelijk kunnen afvuren. Zonder volgorde-
    // bewaking kan een trager, ouder verzoek een net binnengekomen ververst resultaat
    // weer overschrijven — vandaar dit teller-nummer dat late/oude antwoorden negeert.
    const requestId = ++overzichtRequestId.current
    const { data } = await supabase.from('laatste_bericht_per_lid').select('member_id, laatste_bericht')
    if (data && requestId === overzichtRequestId.current) {
      setLedenMetBerichten(new Set(data.map(m => m.member_id)))
      const datums = {}
      data.forEach(m => { datums[m.member_id] = m.laatste_bericht })
      setLaaatsteBerichtDatum(datums)
    }
  }

  useEffect(() => {
    getAllMembers().then(setMembers).catch(() => {})
    refreshBerichtenOverzicht()
  }, [])

  // Live bijwerken: zodra er ergens een bericht bij komt (van of naar om het even welk
  // lid) de lijst verversen, zodat de volgorde altijd klopt — niet alleen voor het
  // geopende gesprek.
  useEffect(() => {
    const channel = supabase
      .channel('admin-alle-berichten-overzicht')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'messages' }, () => {
        refreshBerichtenOverzicht()
      })
      .subscribe()
    return () => channel.unsubscribe()
  }, [])

  useEffect(() => {
    if (!selected) return
    setText('')
    loadThread(selected)
    markeerGelezen(selected).then(() => {
      getOngelezenPerLid().then(setOngelezen).catch(() => {})
      refreshBerichtenOverzicht()
    }).catch(() => {})
  }, [selected])

  // Live bijwerken van het geopende gesprek zelf (nieuwe berichten, gelezen-status)
  useEffect(() => {
    if (!selected) return
    const channel = supabase
      .channel(`admin-thread:${selected}`)
      .on('postgres_changes', {
        event: '*', schema: 'public', table: 'messages',
        filter: `member_id=eq.${selected}`,
      }, () => { loadThread(selected) })
      .subscribe()
    return () => channel.unsubscribe()
  }, [selected])

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [thread])

  async function loadThread(memberId) {
    const msgs = await getMessages(memberId)
    setThread(msgs)
  }

  async function handleSend(e) {
    e.preventDefault()
    if (!selected || !text.trim()) return
    setLoading(true)
    try {
      await sendMessage({ memberId: selected, fromAdmin: true, text })
      setThread(prev => [...prev, { id: Date.now(), member_id: selected, from_admin: true, text, created_at: new Date().toISOString() }])
      setText('')
      await refreshBerichtenOverzicht()
      await sendPushNotification("Nieuw bericht van Vitaal Sterk", text, [selected])
    } catch (err) {
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  async function verwijderBericht(id) {
    if (!window.confirm('Dit bericht definitief verwijderen?')) return
    try {
      await supabase.from('messages').delete().eq('id', id)
      setThread(prev => prev.filter(m => m.id !== id))
      getOngelezenPerLid().then(setOngelezen).catch(() => {})
    } catch (err) {
      console.error(err)
      alert('Verwijderen mislukt.')
    }
  }

  const gefilterd = [...members]
    .sort((a, b) => {
      const aOngelezen = ongelezen[a.member_id] || 0
      const bOngelezen = ongelezen[b.member_id] || 0
      if (bOngelezen !== aOngelezen) return bOngelezen - aOngelezen
      const aDatum = laaatsteBerichtDatum[a.member_id] || ''
      const bDatum = laaatsteBerichtDatum[b.member_id] || ''
      return bDatum.localeCompare(aDatum)
    })
    .filter(m => {
      if (zoek === '') return true
      return m.name?.toLowerCase().includes(zoek.toLowerCase()) ||
        m.member_id?.toLowerCase().includes(zoek.toLowerCase())
    })

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

      {/* Bulk bericht */}
      <div className="card" style={{ marginBottom: 0, borderLeft: '3px solid var(--orange)' }}>
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 8 }}>
          Bulk bericht — alle actieve leden
        </p>
        <form onSubmit={handleBulkSend} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <textarea
            value={bulkText}
            onChange={e => setBulkText(e.target.value)}
            placeholder="Typ een bericht voor alle leden…"
            rows={3}
            style={{ borderRadius: 10, padding: '10px 14px', fontSize: 13, fontFamily: 'Open Sans', border: '1.5px solid var(--border)', background: 'var(--bg)', color: 'var(--text)', resize: 'vertical' }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button
              type="submit"
              disabled={bulkLoading || !bulkText.trim()}
              style={{ background: 'var(--orange)', color: '#fff', border: 'none', borderRadius: 20, padding: '8px 18px', fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'Montserrat', opacity: !bulkText.trim() ? 0.5 : 1, whiteSpace: 'nowrap' }}
            >
              {bulkLoading ? 'Versturen…' : 'Verstuur naar alle leden'}
            </button>
            {bulkFeedback && (
              <p style={{ fontSize: 12, margin: 0, color: bulkFeedback.startsWith('✓') ? 'var(--green-dark)' : 'var(--red)', fontWeight: 600 }}>
                {bulkFeedback}
              </p>
            )}
          </div>
        </form>
      </div>

      {/* Kies een lid */}
      <div className="card" ref={kiesRef} style={{ marginBottom: 0, scrollMarginTop: 8 }}>
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 8 }}>
          Kies een lid
        </p>
        <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Zoek op naam…" style={{ marginBottom: 10 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 300, overflowY: 'auto' }}>
          {gefilterd.map(m => (
            <button
              key={m.member_id}
              onClick={() => setSelected(m.member_id)}
              style={{
                padding: '10px 14px', borderRadius: 10, fontSize: 13, fontWeight: 600,
                border: '1.5px solid', position: 'relative', textAlign: 'left',
                borderColor: selected === m.member_id ? 'var(--green)' : (ongelezen[m.member_id] ? '#e76622' : 'var(--border)'),
                background: selected === m.member_id ? 'var(--green)' : 'var(--bg)',
                color: selected === m.member_id ? '#fff' : 'var(--text)',
                cursor: 'pointer', fontFamily: 'Open Sans',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              }}
            >
              <span>{m.name || m.member_id}</span>
              {ongelezen[m.member_id] > 0 && (
                <span style={{ background: '#e76622', color: '#fff', borderRadius: 20, padding: '2px 8px', fontSize: 10, fontWeight: 700, fontFamily: 'Montserrat', flexShrink: 0 }}>
                  {ongelezen[m.member_id]} nieuw
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {selected && (
        <div className="card" style={{ marginBottom: 0 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', margin: 0 }}>
              Gesprek met {members.find(m => m.member_id === selected)?.name || selected}
            </p>
            <button
              onClick={() => {
                setSelected(null)
                setText('')
                setZoek('')
                setTimeout(() => kiesRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60)
              }}
              style={{ background: 'var(--bg)', border: '1.5px solid var(--border)', borderRadius: 16, padding: '5px 12px', fontSize: 11, fontWeight: 700, fontFamily: 'Montserrat', color: 'var(--green-dark)', cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0 }}
            >
              ↻ Ander lid
            </button>
          </div>
          <div style={{ maxHeight: 220, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 12 }}>
            {thread.length === 0 && <p style={{ fontSize: 12, color: 'var(--muted)' }}>Nog geen berichten.</p>}
            {(() => {
              let vorigeDag = null
              const naam = members.find(m => m.member_id === selected)?.name || selected
              return thread.map(msg => {
                const dezeDag = msg.created_at ? new Date(msg.created_at).toDateString() : null
                const toonScheider = dezeDag && dezeDag !== vorigeDag
                if (dezeDag) vorigeDag = dezeDag
                return (
                  <Fragment key={msg.id}>
                    {toonScheider && (
                      <div style={{ alignSelf: 'center', background: 'var(--green-light)', color: 'var(--green-dark)', fontSize: 10, fontWeight: 700, fontFamily: 'Montserrat', padding: '2px 10px', borderRadius: 12, margin: '8px 0 4px' }}>
                        {dagLabel(msg.created_at)}
                      </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: msg.from_admin ? 'flex-start' : 'flex-end' }}>
                      <div style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 2 }}>
                        {msg.from_admin ? 'Balie' : naam}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexDirection: msg.from_admin ? 'row' : 'row-reverse' }}>
                        <div className={`msg-bubble ${msg.from_admin ? 'msg-in' : 'msg-out'}`} style={{ fontSize: 12 }}>{msg.text}</div>
                        <button
                          onClick={() => verwijderBericht(msg.id)}
                          title="Bericht verwijderen"
                          aria-label="Bericht verwijderen"
                          style={{ background: 'transparent', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 15, lineHeight: 1, padding: 2, flexShrink: 0 }}
                        >
                          ×
                        </button>
                      </div>
                      {msg.created_at && (
                        <span className="msg-time" style={{ margin: '2px 4px 4px' }}>
                          {new Date(msg.created_at).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}
                          {msg.from_admin && (
                            msg.gelezen
                              ? <span style={{ color: 'var(--green-dark)', fontWeight: 700 }}> · ✓ Gelezen</span>
                              : ' · Verzonden'
                          )}
                        </span>
                      )}
                    </div>
                  </Fragment>
                )
              })
            })()}
            <div ref={bottomRef} />
          </div>
          <form onSubmit={handleSend} style={{ display: 'flex', gap: 8 }}>
            <input value={text} onChange={e => setText(e.target.value)} placeholder="Typ een bericht…" style={{ flex: 1, borderRadius: 20, padding: '8px 14px' }} />
            <button type="submit" disabled={loading || !text.trim()} style={{ background: 'var(--green)', color: '#fff', border: 'none', borderRadius: 20, padding: '8px 14px', fontWeight: 700, fontSize: 12, cursor: 'pointer', fontFamily: 'Montserrat', opacity: !text.trim() ? 0.5 : 1 }}>
              {loading ? '…' : 'Stuur'}
            </button>
          </form>
        </div>
      )}
    </div>
  )
}

// ── Leden ─────────────────────────────────────────────

function MembersTab() {
  const [members, setMembers] = useState([])
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [memberId, setMemberId] = useState('')
  const [plan, setPlan] = useState('12 maanden')
  const [feedback, setFeedback] = useState('')
  const [loading, setLoading] = useState(false)
  const [zoek, setZoek] = useState('')
  const [geselecteerd, setGeselecteerd] = useState(null)
  const [appFilter, setAppFilter] = useState('alle')

  useEffect(() => { loadMembers() }, [])

  async function loadMembers() {
    const data = await getAllMembers()
    setMembers(data)
  }

  async function handleToggle(member) {
    await toggleMemberStatus(member.id, member.status)
    loadMembers()
  }

  async function handleAdd(e) {
    e.preventDefault()
    if (!name.trim() || !email.trim() || !memberId.trim()) return
    setLoading(true)
    setFeedback('')
    try {
      const tijdelijkWachtwoord = Math.random().toString(36).slice(2, 10) + 'Aa1!'
      const userId = await createMemberAccount(email.trim().toLowerCase(), tijdelijkWachtwoord, { member_id: memberId, name })
      if (!userId) throw new Error('Gebruiker aanmaken mislukt.')

      const { error: insertError } = await supabase.from('members').insert({
        user_id: userId,
        member_id: memberId.trim(),
        name: name.trim(),
        email: email.trim().toLowerCase(),
        plan,
        status: 'actief',
      })
      if (insertError) throw insertError

      try {
        await sendWelcomeEmail({ name: name.trim(), email: email.trim().toLowerCase(), memberId: memberId.trim(), password: tijdelijkWachtwoord })
        setFeedback(`✓ ${name} is toegevoegd. Welkomstmail met downloadlinks + wachtwoord is verstuurd naar ${email.trim()}.`)
      } catch (mailErr) {
        // Mail versturen mislukt (bv. RESEND_API_KEY nog niet ingesteld) — dan toch het
        // wachtwoord tonen zodat je het zelf kunt doorgeven, in plaats van het kwijt te raken.
        // Foutmelding erbij voor het debuggen (tijdelijk, zodra dit stabiel draait mag dit weer weg).
        console.error('sendWelcomeEmail error:', mailErr)
        setFeedback(`✓ ${name} is toegevoegd, maar de welkomstmail kon niet worden verstuurd (${mailErr?.message || mailErr}). Wachtwoord: ${tijdelijkWachtwoord} — geef dit zelf even door.`)
      }
      setName(''); setEmail(''); setMemberId('')
      loadMembers()
    } catch (err) {
      setFeedback('Fout: ' + err.message)
    } finally {
      setLoading(false)
    }
  }

  const gefilterd = [...members]
    .sort((a, b) => (a.name || '').localeCompare(b.name || '', 'nl'))
    .filter(m =>
      zoek === '' ||
      m.name?.toLowerCase().includes(zoek.toLowerCase()) ||
      m.member_id?.toLowerCase().includes(zoek.toLowerCase())
    )
    .filter(m =>
      appFilter === 'alle' ||
      (appFilter === 'app' && appGebruik(m).heeftApp) ||
      (appFilter === 'geen' && !appGebruik(m).heeftApp && m.status === 'actief')
    )

  const actieveLeden = members.filter(m => m.status === 'actief')
  const aantalMetApp = actieveLeden.filter(m => appGebruik(m).heeftApp).length

  return (
    <>
    <div>
      <div className="card">
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 12, color: 'var(--muted)', fontFamily: 'Montserrat' }}>
          Lid toevoegen
        </p>
        <form onSubmit={handleAdd}>
          <div className="form-group">
            <label className="form-label">Volledige naam</label>
            <input value={name} onChange={e => setName(e.target.value)} placeholder="bijv. Jan de Vries" />
          </div>
          <div className="form-group">
            <label className="form-label">Emailadres</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="jan@email.nl" />
          </div>
          <div className="form-group">
            <label className="form-label">Lidnummer</label>
            <input value={memberId} onChange={e => setMemberId(e.target.value)} placeholder="bijv. 200769162" />
          </div>
          <div className="form-group">
            <label className="form-label">Abonnement</label>
            <select value={plan} onChange={e => setPlan(e.target.value)}>
              <option>12 maanden</option>
              <option>18 maanden</option>
              <option>24 maanden</option>
            </select>
          </div>
          {feedback && (
            <p style={{ fontSize: 12, color: feedback.startsWith('✓') ? 'var(--green-dark)' : 'var(--red)', marginBottom: 8, lineHeight: 1.5 }}>
              {feedback}
            </p>
          )}
          <button className="btn-primary" disabled={loading}>{loading ? 'Bezig…' : 'Lid toevoegen'}</button>
        </form>
        <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 12, lineHeight: 1.6 }}>
          Het account krijgt een willekeurig, direct bruikbaar wachtwoord. Het lid ontvangt automatisch een welkomstmail met de downloadlinks en dit wachtwoord, en kan het later altijd zelf wijzigen via "Wachtwoord vergeten".
        </p>
      </div>

      <div className="card">
        <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, color: 'var(--muted)', fontFamily: 'Montserrat' }}>
          Leden ({members.length})
        </p>
        <input value={zoek} onChange={e => setZoek(e.target.value)} placeholder="Zoek op naam of lidnummer…" style={{ marginBottom: 8 }} />
        <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 8 }}>
          {aantalMetApp} van de {actieveLeden.length} actieve leden gebruiken de app
        </p>
        <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
          {[['alle', 'Alle leden'], ['app', 'Heeft de app'], ['geen', 'Nog geen app']].map(([waarde, label]) => (
            <button
              key={waarde}
              onClick={() => setAppFilter(waarde)}
              style={{
                flex: 1, padding: '6px 4px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                fontFamily: 'Montserrat', cursor: 'pointer', border: '1.5px solid var(--green)',
                background: appFilter === waarde ? 'var(--green)' : 'transparent',
                color: appFilter === waarde ? '#fff' : 'var(--green-dark)',
              }}
            >
              {label}
            </button>
          ))}
        </div>
        {gefilterd.length === 0 && <p style={{ fontSize: 13, color: 'var(--muted)' }}>Geen leden gevonden.</p>}
        {gefilterd.map(m => {
          const initials = m.name?.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || '?'
          return (
            <div key={m.id} className="member-row" onClick={() => setGeselecteerd(m)} style={{ cursor: 'pointer' }}>
              <div className="avatar" style={{ width: 36, height: 36, fontSize: 13 }}>{initials}</div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 13, fontWeight: 600 }}>{m.name}</p>
                <p style={{ fontSize: 11, color: 'var(--muted)' }}>{m.member_id} · {m.plan}</p>
                <p style={{ fontSize: 11, color: appGebruik(m).kleur, marginTop: 2 }}>{appGebruik(m).kort}</p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div className={`status-dot ${m.status === 'actief' ? 'active' : 'inactive'}`} />
                <span style={{ fontSize: 11, color: m.status === 'actief' ? 'var(--green)' : 'var(--red)' }}>{m.status}</span>
                <span style={{ fontSize: 16, color: 'var(--muted)', marginLeft: 4 }}>›</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
    {geselecteerd && (
      <LidDetail
        lid={geselecteerd}
        onClose={() => setGeselecteerd(null)}
        onUpdate={(updated) => {
          setMembers(prev => prev.map(m => m.id === updated.id ? updated : m))
          setGeselecteerd(updated)
        }}
      />
    )}
  </>
  )
}

// ── App-gebruik ───────────────────────────────────────
// Vat samen of en waarmee een lid de app gebruikt, op basis van
// app_platform / app_laatst_geopend / web_laatst_geopend (zie registreer_app_opening).
function geledenTekst(datum) {
  const dagen = Math.floor((Date.now() - new Date(datum).getTime()) / (24 * 3600 * 1000))
  if (dagen <= 0) return 'vandaag'
  if (dagen === 1) return 'gisteren'
  if (dagen < 60) return `${dagen} dagen geleden`
  return `${Math.floor(dagen / 30)} maanden geleden`
}

function appGebruik(m) {
  if (m.app_laatst_geopend) {
    const naam = m.app_platform === 'android' ? 'Android-app' : 'iPhone-app'
    return { heeftApp: true, kort: `📱 ${naam} · ${geledenTekst(m.app_laatst_geopend)}`, kleur: 'var(--green-dark)' }
  }
  if (m.web_laatst_geopend) {
    return { heeftApp: false, kort: `🌐 Alleen website · ${geledenTekst(m.web_laatst_geopend)}`, kleur: 'var(--muted)' }
  }
  return { heeftApp: false, kort: '⚪ Nog nooit geopend', kleur: 'var(--red)' }
}

// ── Lid Detail ────────────────────────────────────────

function LidDetail({ lid, onClose, onUpdate }) {
  const [bezoeken, setBezoeken] = useState([])
  const [berichten, setBerichten] = useState([])
  const [uitnodigingLoading, setUitnodigingLoading] = useState(false)
  const [uitnodigingFeedback, setUitnodigingFeedback] = useState('')
  const [statusLoading, setStatusLoading] = useState(false)

  useEffect(() => {
    supabase.from('bezoeken').select('*')
      .eq('member_id', lid.member_id)
      .order('bezocht_op', { ascending: true })
      .then(({ data }) => setBezoeken(data ?? []))

    supabase.from('messages').select('*')
      .eq('member_id', lid.member_id)
      .order('created_at', { ascending: false })
      .limit(3)
      .then(({ data }) => setBerichten((data ?? []).reverse()))
  }, [lid.member_id])

  async function stuurUitnodiging() {
    if (!lid.email) {
      setUitnodigingFeedback("Geen e-mailadres bekend voor dit lid.")
      return
    }
    setUitnodigingLoading(true)
    try {
      await supabase.auth.resetPasswordForEmail(lid.email || '', {
        redirectTo: 'https://app.vitaal-sterk.nl/reset-wachtwoord',
      })
      setUitnodigingFeedback('✓ Uitnodigingsmail verstuurd naar ' + lid.email)
    } catch (err) {
      setUitnodigingFeedback('Fout: ' + err.message)
    } finally {
      setUitnodigingLoading(false)
    }
  }

  async function toggleStatus() {
    setStatusLoading(true)
    const nieuw = lid.status === 'actief' ? 'inactief' : 'actief'
    await supabase.from('members').update({ status: nieuw }).eq('id', lid.id)
    onUpdate({ ...lid, status: nieuw })
    setStatusLoading(false)
  }

  const MAANDEN = ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec']

  // Bezoekstatistiek (bezoeken staan oplopend gesorteerd: oudste eerst)
  const nuMs = Date.now()
  const dagMs = 24 * 3600 * 1000
  const weekMs = 7 * dagMs
  const nuDate = new Date()
  const totaalBezoeken = bezoeken.length
  const dezeMaand = bezoeken.filter(b => {
    const d = new Date(b.bezocht_op)
    return d.getMonth() === nuDate.getMonth() && d.getFullYear() === nuDate.getFullYear()
  }).length
  const laatste = totaalBezoeken ? new Date(bezoeken[totaalBezoeken - 1].bezocht_op) : null
  const dagenGeleden = laatste ? Math.floor((nuMs - laatste.getTime()) / dagMs) : null
  const laatsteTekst = !laatste ? '' : dagenGeleden <= 0 ? 'vandaag' : dagenGeleden === 1 ? 'gisteren' : `${dagenGeleden} dagen geleden`
  const eersteMs = totaalBezoeken ? new Date(bezoeken[0].bezocht_op).getTime() : nuMs
  const wekenActief = Math.max(1, Math.min(8, Math.ceil((nuMs - eersteMs) / weekMs)))
  const recent8w = bezoeken.filter(b => (nuMs - new Date(b.bezocht_op).getTime()) <= 8 * weekMs).length
  const gemPerWeek = totaalBezoeken ? (recent8w / wekenActief) : 0

  const DAGEN = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za']
  const perDag = [0, 0, 0, 0, 0, 0, 0]
  bezoeken.forEach(b => { perDag[new Date(b.bezocht_op).getDay()]++ })
  const maxDag = Math.max(...perDag)
  const vasteDagen = maxDag > 0 ? perDag.map((n, i) => ({ n, i })).filter(x => x.n === maxDag).map(x => DAGEN[x.i]) : []
  const komtOpTekst = vasteDagen.length === 0 ? '' : vasteDagen.length > 3 ? 'wisselend' : vasteDagen.join(', ')

  const StatTegel = ({ waarde, label, sub }) => (
    <div style={{ background: 'var(--bg)', borderRadius: 10, padding: '10px 12px' }}>
      <div style={{ fontSize: 20, fontWeight: 800, fontFamily: 'Montserrat', color: 'var(--text)', lineHeight: 1.1 }}>{waarde}</div>
      {sub && <div style={{ fontSize: 10, color: 'var(--green-dark)', fontWeight: 600, marginTop: 1 }}>{sub}</div>}
      <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{label}</div>
    </div>
  )

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', alignItems: 'flex-end',
    }}>
      <div style={{
        background: 'var(--bg)', borderRadius: '20px 20px 0 0',
        width: '100%', maxHeight: '85vh', overflowY: 'auto',
        padding: 20,
      }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div className="avatar" style={{ width: 44, height: 44, fontSize: 16 }}>
              {lid.name?.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase()}
            </div>
            <div>
              <p style={{ fontFamily: 'Montserrat', fontWeight: 700, fontSize: 15 }}>{lid.name}</p>
              <p style={{ fontSize: 11, color: 'var(--muted)' }}>Customer ID: {lid.member_id}</p>
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'var(--border)', border: 'none', borderRadius: '50%', width: 32, height: 32, cursor: 'pointer', fontSize: 16, color: 'var(--muted)' }}>✕</button>
        </div>

        {/* Info */}
        <div className="card" style={{ marginBottom: 10 }}>
          {[
            { label: 'Abonnement', value: lid.plan },
            { label: 'Status', value: lid.status },
            { label: 'Email', value: lid.email || '—' },
            { label: 'App', value: appGebruik(lid).kort },
          ].map(({ label, value }) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)' }}>
              <span style={{ fontSize: 12, color: 'var(--muted)' }}>{label}</span>
              <span style={{ fontSize: 12, fontWeight: 600 }}>{value}</span>
            </div>
          ))}
          <div style={{ paddingTop: 12, display: 'flex', gap: 8 }}>
            <button
              onClick={toggleStatus}
              disabled={statusLoading}
              style={{
                flex: 1, padding: '8px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                border: '1.5px solid', cursor: 'pointer', fontFamily: 'Montserrat',
                background: lid.status === 'actief' ? '#fdecea' : 'var(--green-light)',
                color: lid.status === 'actief' ? 'var(--red)' : 'var(--green-dark)',
                borderColor: lid.status === 'actief' ? 'var(--red)' : 'var(--green)',
              }}
            >
              {lid.status === 'actief' ? 'Zet inactief' : 'Zet actief'}
            </button>
            <button
              onClick={stuurUitnodiging}
              disabled={uitnodigingLoading}
              style={{
                flex: 2, padding: '8px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                border: '1.5px solid var(--green)', cursor: 'pointer', fontFamily: 'Montserrat',
                background: 'var(--green)', color: '#fff',
              }}
            >
              {uitnodigingLoading ? 'Bezig…' : '✉ Stuur uitnodiging'}
            </button>
          </div>
          {uitnodigingFeedback && (
            <p style={{ fontSize: 11, color: uitnodigingFeedback.startsWith('✓') ? 'var(--green-dark)' : 'var(--red)', marginTop: 8 }}>
              {uitnodigingFeedback}
            </p>
          )}
        </div>

        {/* Bezoekstatistiek */}
        <div className="card" style={{ marginBottom: 10 }}>
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 10 }}>
            Bezoekstatistiek
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <StatTegel waarde={gemPerWeek.toFixed(1).replace('.', ',')} label="gem. per week" />
            <StatTegel waarde={dezeMaand} label="deze maand" />
            <StatTegel waarde={totaalBezoeken} label="totaal bezoeken" />
            <StatTegel
              waarde={laatste ? `${laatste.getDate()} ${MAANDEN[laatste.getMonth()]}` : '—'}
              sub={laatsteTekst}
              label="laatste bezoek"
            />
          </div>
          {komtOpTekst && (
            <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 12 }}>
              Komt meestal op: <strong style={{ color: 'var(--text)' }}>{komtOpTekst}</strong>
            </p>
          )}
        </div>

        {/* Laatste berichten */}
        <div className="card">
          <p style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: 'var(--muted)', fontFamily: 'Montserrat', marginBottom: 10 }}>
            Laatste berichten
          </p>
          {berichten.length === 0 && <p style={{ fontSize: 12, color: 'var(--muted)' }}>Geen berichten.</p>}
          {berichten.map(msg => (
            <div key={msg.id} style={{ display: 'flex', flexDirection: 'column', alignItems: msg.from_admin ? 'flex-start' : 'flex-end', marginBottom: 6 }}>
              <span style={{ fontSize: 9, color: 'var(--muted)', marginBottom: 2 }}>{msg.from_admin ? 'Balie' : lid.name}</span>
              <div className={`msg-bubble ${msg.from_admin ? 'msg-in' : 'msg-out'}`} style={{ fontSize: 12 }}>{msg.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
